import React from "react";

function ParameterNameField({ value, onChange, disabled }) {

    return (
        <div className="oct-shared-popup__field">
            <label className="oct-shared-popup__label" htmlFor="parameter-name">
                Parameter Name <span className="oct-shared-popup__required-mark">*</span>
            </label>
            <input
                className="oct-shared-popup__input"
                id="parameter-name"
                value={value}
                autoComplete="off"
                disabled={disabled}
                placeholder="Enter parameter name"
                onChange={event => onChange(event.target.value)}
            />
        </div>
    )

}

export default ParameterNameField;
